module.exports = __webpack_public_path__ + "assets/img/2403.24dc1f57.svg";